import React from 'react';

interface SearchEmptyStateProps {
  /** The search query the user typed */
  query: string;
  /** Display name for the entity type, e.g. "Spaces" or "events" */
  entityName: string;
  /** Override the heading. Falls back to "No {entityName} found". */
  title?: string;
  /**
   * Override the body line. Falls back to "No {entityName} matching "{query}"". `null` shows the
   * title alone (the Partners page search, TECH-86 C4).
   */
  message?: string | null;
}

/**
 * Illustrated empty state for search-with-no-results.
 * Used by Spaces (CommunityList), Events (EventTimeline), and the event attendees roster. The
 * optional title/message let people-shaped surfaces speak in the brand's "who's going" voice
 * instead of treating people as a generic entity.
 */
export const SearchEmptyState: React.FC<SearchEmptyStateProps> = ({
  query,
  entityName,
  title,
  message,
}) => (
  <div className="flex flex-col items-center justify-center py-16 px-6">
    <img src="/assets/no_spaces_found.svg" alt="" className="w-20 h-20 mb-2" aria-hidden="true" />
    <h3 className="text-lg font-medium text-gray-900 text-center">
      {title ?? `No ${entityName} found`}
    </h3>
    {message !== null && (
      <p className="text-sm text-gray-500 text-center mt-1 leading-4">
        {message ?? `No ${entityName} matching “${query}”`}
      </p>
    )}
  </div>
);
